import { LuClipboardList, LuPhone } from "react-icons/lu";

import { business } from "../content/site";

/**
 * MobileCallBar — the sticky bottom conversion bar, below `lg` only.
 *
 * For a residential contractor, a phone call is the conversion. This bar keeps
 * the call one thumb-press away on every scroll position, with "Request
 * service" as the quieter fallback for people who will not call.
 *
 * LAYOUT NOTE for whoever owns the footer:
 *   This bar is fixed. Give the page's last element `pb-24 lg:pb-0` (or add
 *   `paddingBottom: MOBILE_CALL_BAR_HEIGHT` plus the safe-area inset) so the
 *   final footer row is never trapped underneath it.
 *
 * Height below `lg`:
 *   12px top padding + 44px control + 12px bottom padding + 1px top border
 *   = 69px on one line. At 280-320px "Request service" wraps to two lines and
 *   the bar grows to roughly 85px. Add `env(safe-area-inset-bottom)` on top of
 *   that. `pb-24` (96px) clears every case with room to spare.
 *
 * `viewport-fit=cover` is set in public/index.html; without it the safe-area
 * inset always resolves to 0 and the bar sits under the iOS home indicator.
 */
export const MOBILE_CALL_BAR_HEIGHT = "69px";

const MobileCallBar = () => (
  <div
    className="lg:hidden fixed inset-x-0 bottom-0 z-50 border-t border-line bg-surface shadow-lg"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <nav
      aria-label="Contact actions"
      className="flex items-stretch gap-2 px-gutter py-3"
    >
      <a
        href={business.phone.href}
        className="btn-urgent flex-[3] min-w-0 px-2 sm:px-4 text-body-sm sm:text-body"
        aria-label={`Call ${business.shortName} at ${business.phone.display}`}
      >
        <LuPhone aria-hidden="true" className="h-5 w-5 shrink-0" />
        {/* The call gets 3/5 of the row so the full number stays on one line
            down to 320px. At 280px it wraps at its space rather than
            overflowing, and items-stretch keeps both controls the same height. */}
        <span className="tabular min-w-0 text-center leading-tight">
          {business.phone.display}
        </span>
      </a>

      <a
        href="/#contact"
        className="btn-outline flex-[2] min-w-0 px-2 sm:px-4 text-body-sm sm:text-body"
      >
        <LuClipboardList aria-hidden="true" className="h-5 w-5 shrink-0" />
        <span className="min-w-0 text-center leading-tight [overflow-wrap:anywhere]">
          Request service
        </span>
      </a>
    </nav>
  </div>
);

export default MobileCallBar;
